import { render, staticRenderFns } from "./aloneHome.vue?vue&type=template&id=2c4b4de7&scoped=true&"
import script from "./aloneHome.vue?vue&type=script&lang=js&"
export * from "./aloneHome.vue?vue&type=script&lang=js&"
import style0 from "./aloneHome.vue?vue&type=style&index=0&id=2c4b4de7&prod&lang=less&scoped=true&"
import style1 from "./aloneHome.vue?vue&type=style&index=1&id=2c4b4de7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b4de7",
  null
  
)

export default component.exports